import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
// import { LogError } from "../../../../components/AppInsights/TelemetryService";

export function useSuppressCheck() {
  const { oktaAuth } = useOktaAuth();

  async function suppressCheckApi({ selectedItems, submittedFormData, user }) {
    if (!selectedItems || selectedItems.length <= 0) {
      throw new Error("Please select at least one record to suppress check");
    }

    const accessToken = oktaAuth.getAccessToken();
    const formatSelectedItem = selectedItems.map((item) => item.pmid).join(",");

    const result = await axios
      .post(
        "api/RemittanceLookup/AdminRemittanceSuppressChecks",
        {
          user: user,
          rpid: submittedFormData.selectedParentCompany,
          checkedItems: formatSelectedItem,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      .then((response) => {
        alert("Checks have been successfully suppressed");
        return response.data;
      })
      .catch((error) => {
        // LogError(error);
        throw new Error(error);
      });

    return result;
  }

  return useMutation({
    mutationFn: suppressCheckApi,
  });
}
